<template>
  <ZtTooltip :content="tooltip" :placement="tooltipPlacement">
    <component
      :is="href ? 'a' : 'button'"
      @click="handleClick"
      :data-testid="dataTestid"
      class="meta-button flex gap-1 items-center"
      :class="getClass()"
      :disabled="props.disabled"
      :href="href"
    >
      <slot /></component
  ></ZtTooltip>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import { ZtTooltip } from '@/storybook/tooltip';
import { Placement } from '@floating-ui/vue';

const props = defineProps<{
  tooltip: string;
  tooltipPlacement: Placement;
  dataTestid?: string;
  href?: string;
  class?: string;
  disabled?: boolean;
}>();
const { tooltip, tooltipPlacement } = toRefs(props);

const emit = defineEmits(['click']);
const handleClick = (event: MouseEvent) => {
  if (!props.href) {
    event.preventDefault();
  }
  emit('click', event);
};

const getClass = () => {
  return {
    disabled: props.disabled,
    [props.class || '']: true,
  };
};
</script>

<style scoped>
.meta-button:hover {
  @apply -m-0.5 p-0.5 rounded-md bg-slate-100 dark:bg-zinc-800;
}
.meta-button.disabled {
  @apply cursor-not-allowed opacity-50;
}
</style>
